/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca, Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
import Activity from '../../../common/models/Activity';

const DEFAULT_ACTIVITIES = [
	new Activity({
		attributes: {
			id: 'exp',
		},
	}),
];

export default class LeaderboardState extends PaginatedListState {
	get type() {
		return `gamilytics/leaderboard/${this.activityType}`;
	}

	get activityType() {
		return this.params?.activityType || 'exp';
	}

	constructor(params, page, pageSize) {
		super(params, page, pageSize);
		this.activities = DEFAULT_ACTIVITIES;
		this.refreshedActivities = false;
	}

	requestParams() {
		const params = { ...super.requestParams() };
		delete params.activityType;
		return params;
	}

	stickyParams() {
		return {
			timeSpan: m.route.param('timeSpan'),
			group: m.route.param('group'),
			level: m.route.param('level'),
		};
	}

	refreshActivities() {
		if (this.refreshedActivities) {
			return;
		}

		return app.store.find('gamilytics_activities', { leaderboard: true }).then((activities) => {
			this.activities = [...DEFAULT_ACTIVITIES, ...activities];
			this.refreshedActivities = true;
			m.redraw();
		});
	}

	getPodium() {
		// The first 3 items of the first page
		let podium = this.pages[0]?.items.slice(0, 3) || [];

		if (podium.length === 3 || podium.length === 2) {
			// invert the 1st and 2nd items
			const second = podium[1];
			podium[1] = podium[0];
			podium[0] = second;
		}

		return podium;
	}

	/**
	 * @override
	 */
	getAllItems() {
		// All items of all pages except the podium
		return this.pages.reduce((items, page, i) => {
			if (i === 0) {
				return page.items.slice(3);
			}
			return [...items, ...page.items];
		}, []);
	}

	hasItems() {
		// We need at least 3 items to show the podium
		return this.getPodium().length > 0;
	}
}
